<template>
  <v-container
    class="redirect-page"
    fill-height
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        class="text-center"
      >
        <v-card>
          <v-card-title class="headline">
            Redirecting...
          </v-card-title>
          <v-card-text>
            <p>Please wait while we redirect you to the new page.</p>
            <v-progress-circular
              indeterminate
              color="primary"
              class="mt-4"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RedirectPage',
  mounted() {
    // Simulate a redirect after 3 seconds
    // setTimeout(() => {
    //   window.location.href = 'https://example.com'
    // }, 3000)
  },
}
</script>

<style scoped>
.redirect-page {
  background-color: #f5f5f5;
  height: 100vh;
}
</style>
